export enum ShowContent {
    STAND = 'stand',
    TABLE = 'table'
}